import { IconActionMap16, IconActionTable16 } from '@cian/ui-kit-design-tokens/icons';

import { type FC, useCallback, useState } from 'react';

import { ChipsOption } from 'shared/models/ChipsOption';
import { PikProjectsChipsDataService } from 'shared/services/ChipsDataService';
import { useApplicationContext } from 'shared/utils/applicationContext';

import { PikProjects } from './PikProjects';
import { type IPikProjectsItemViewModel, PikProjectsItemViewModel } from './external/models/PikProjectsItemViewModel';

const pikProjectsChipsDataService = new PikProjectsChipsDataService([
  new PikProjectsItemViewModel(new ChipsOption('Плитками', undefined, <IconActionTable16 />), 'list'),
  new PikProjectsItemViewModel(new ChipsOption('На карте', undefined, <IconActionMap16 />), 'map'),
]);

export const PikProjectsContainer: FC = () => {
  const { logger } = useApplicationContext();

  const [activePikProjectsItem, setActivePikProjectsItem] = useState<IPikProjectsItemViewModel>(
    pikProjectsChipsDataService.defaultItem,
  );

  const handleChange = useCallback<(value: string[]) => void>(
    value => {
      setActivePikProjectsItem(pikProjectsChipsDataService.getActiveItem(value[0], logger));
    },
    [logger],
  );

  return (
    <PikProjects
      activePikProjectsItem={activePikProjectsItem}
      chipsOptions={pikProjectsChipsDataService.chipsOptions}
      onChange={handleChange}
    />
  );
};
